export default class Table {
  public static DATE_FORMAT_STRING = 'dd.MM.yyyy';
  public static DATETIME_FORMAT_STRING = 'dd.MM.yyyy HH:mm';
  public static TIME_FORMAT_STRING = 'HH:mm:ss';
  public static DATE_MONTH_FORMAT_STRING = 'MM. yyyy';
}
